import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-container',
  imports: [CommonModule],
  template: `
    <div class="container {{ noPadding ? '' : 'px-4' }} w-full md:max-w-3xl max-w-[100vw] mx-auto">
      <ng-content/>
    </div>`
})
export class ContainerComponent {
  @Input() public noPadding = false;
}
